import React, { useEffect, useState } from "react";
import { BaSeIcon } from "@base/react";
import {
  FilterClearButton,
  FilterContainer,
  FlexDirectionWrapper,
  MainContent,
  SubTitle,
} from "../../../../../components/StyledComponents";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Accordion from "@material-ui/core/Accordion";
import { ExcelExportAdmin } from "../../../../../components/ExcelExportAdmin";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { formatDateToBR } from "../../../../../utils/time";
import { SearchInputAdmin } from "../../../../../components/SearchInputAdmin";
import moment from "moment";
import { removeEmpty } from "../../../../../utils/utils";
import { numberLocale } from "../../../../../utils/mask";
import { AccordionDetails } from "@material-ui/core";
import filtersModel from "../../../filters.model";
import { TableAdminReports } from "../../../../../components/TableAdmin/TableAdminReports";
import { LeadsEventosService } from "../../../services/LeadsEventosService";
import { FiltrosLeadsEventos } from "./filtros";
import { handleModalAdmin } from "../../../../../utils/handleModalAdmin";

export const GerenciarLeadsEventos = () => {
  const {
    handleOrderClick,
    handleInputPageChange,
    handlePageChange,
    onLinesPerPageChange,
    filters,
    setFilters,
    paginationFilters,
    setPaginationFilters,
    inputSearchValue,
    setInputSearchValue,
    isLoading,
    setIsLoading,
    filterOptions,
    setFilterOptions,
    cleanSelectedFiltersFromModel,

    // handleFiltros
    handleDTInicioChange,
    handleDTFimChange,
    handleMesChange,
    handleAnoChange,
    handleUFEventoChange,
    handleEventoChange,

    // CONSTANTS
    filtersSelectedValues,
    showModal,
  } = filtersModel();

  const [data, setData] = useState([]);

  const getDataExcel = async () => {
    const bodyParams = removeEmpty({
      ...filters,
      oqueVoceProcura: inputSearchValue,
    });
    const pageFilter = { ...paginationFilters, page: 0, linesPerPage: 1000 };
    const response = await LeadsEventosService.findAll(pageFilter, bodyParams);

    return response?.content?.map((xls) => ({
      NOME: xls?.administrador.nome,
      EMAIL: xls?.administrador.email,
      NOME_EVENTO: xls?.nomeEvento,
      UF: xls?.administrador?.uf?.sigla,
      DATA_INICIO: moment(xls?.dataInicio).format("DD/MM/YYYY"),
      DATA_FIM: moment(xls?.dataFim).format("DD/MM/YYYY"),
      PARTICIPOU_ACAO_SEBRAE: !!xls?.participouAcao ? "Sim" : "Não",
      GEOLOCALIZACAO: `${xls?.geolocalizacao.latitude}, ${xls?.geolocalizacao.longitude}`,
    }));
  };

  const getData = async (source) => {
    const bodyParams = removeEmpty({
      ...filters,
      oqueVoceProcura: inputSearchValue,
    });

    const response = await LeadsEventosService.findAll(
      paginationFilters,
      bodyParams,
      source
    );
    setIsLoading(false);
    setData(response);
  };

  const getFilterOptionsData = async () => {
    setFilterOptions({});
    const response = await LeadsEventosService.getFilterOptions();
    setFilterOptions(response);
  };

  const onClickClearFilters = () => {
    setIsLoading(true);
    setData([]);
    setInputSearchValue(null);
    setFilters({
      status: "",
    });
    setPaginationFilters({
      page: 0,
      linesPerPage: 10,
      orderBy: "id",
      direction: "DESC",
    });
    cleanSelectedFiltersFromModel();
  };

  useEffect(() => {
    setIsLoading(true);
    setData([]);
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationFilters, filters, inputSearchValue]);

  useEffect(() => {
    getFilterOptionsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const tableColumns = [
    {
      field: "nomeEvento",
      id: "nomeEvento",
      label: "Nome Evento",
      minWidth: 200,
    },
    {
      field: "dataInicio",
      id: "dataInicio",
      label: "Data",
      minWidth: 120,
    },
    {
      field: "administrador",
      subfield: "nome",
      id: "administrador",
      label: "Nome",
      minWidth: 200,
    },
    {
      field: "administrador",
      subfield: "uf",
      subfield2: "sigla",
      id: "administrador",
      label: "UF",
      minWidth: 50,
    },
    {
      field: "administrador",
      subfield: "email",
      id: "administrador",
      label: "E-mail",
      minWidth: 100,
    },
    {
      field: "administrador",
      subfield: "telefone",
      id: "administrador",
      label: "Telefone",
      minWidth: 100,
    },
    {
      field: "actions",
      id: "actions",
      label: "Status",
      minWidth: 30,
    },
  ];

  const renderFilters = (color) => {
    return (
      <FilterContainer>
        <Accordion style={{ backgroundColor: "#F8F8F8", marginBottom: 20 }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <BaSeIcon
              name="filter"
              color={color}
              size={25}
              description="Ícone de filtro"
            />
            <p
              style={{ color: color, fontWeight: "bold", marginTop: "0.2rem" }}
            >
              Filtrar
            </p>
            <FilterClearButton
              color={color}
              onClick={(e) => {
                e.stopPropagation();
                onClickClearFilters();
              }}
            >
              <BaSeIcon
                name="close"
                size={10}
                color={color}
                description="Limpar filtros"
              />
              <p
                style={{
                  fontSize: "12px",
                  color: color,
                  borderBottom: `1px solid ${color}`,
                }}
              >
                Limpar filtros
              </p>
            </FilterClearButton>
          </AccordionSummary>
          <AccordionDetails>
            <FiltrosLeadsEventos
              filterOptions={filterOptions}
              filtersSelectedValues={filtersSelectedValues}
              onDataInicioChange={handleDTInicioChange}
              onDataFimChange={handleDTFimChange}
              onMesChange={handleMesChange}
              onAnoChange={handleAnoChange}
              onUFChange={handleUFEventoChange}
              onEventoChange={handleEventoChange}
            />
          </AccordionDetails>
        </Accordion>
      </FilterContainer>
    );
  };

  const handleDeleteClick = (id) => {
    handleModalAdmin({
      title: `Excluir`,
      content: `Você tem certeza que deseja excluir a participação no evento?`,
      msgOnSuccess: `Participação no evento excluída com sucesso`,
      showAPIErrorIfAvailable: true,
      onFinish: () => {
        setIsLoading(true);
        setData([]);
        getData();
      },
      onConfirmClick: async () =>
        await LeadsEventosService.deleteParticipacaoEvento(id),
      showModal: showModal,
    });
  };

  return (
    <MainContent>
      <SubTitle color="#00ccff">
        <>
          <h3>Usuários</h3>
          <SearchInputAdmin
            value={inputSearchValue}
            onChange={setInputSearchValue}
            placeholder="Digite o CPF que deseja buscar"
            iconColor="#00ccff"
          />
        </>
      </SubTitle>

      {renderFilters("#00ccff")}

      <FlexDirectionWrapper
        style={{ justifyContent: "space-between", marginTop: "12px" }}
      >
        <div>
          <p style={{ fontWeight: "bold", color: "#00ccff" }}>
            {numberLocale(data?.totalElements)}{" "}
            <strong className="find-results"> resultados encontrados </strong>
          </p>
        </div>

        <ExcelExportAdmin
          filename={`Exportacao_Usuarios_${formatDateToBR(new Date())}`}
          handleDataCallback={getDataExcel}
          isCsv
        />
      </FlexDirectionWrapper>

      <TableAdminReports
        data={data}
        columnAction={"actions"}
        paginationFilters={paginationFilters}
        linesPerPageFilters={paginationFilters?.linesPerPage}
        pagination={true}
        totalPages={data?.totalPages}
        columns={tableColumns}
        isLoading={isLoading}
        tableColor={"#00ccff"}
        lineColor={"rgb(248,251,255, 0.9)"}
        onLinesPerPageChange={onLinesPerPageChange}
        onPagePreviousChange={handlePageChange}
        onPageNextChange={handlePageChange}
        handleOrderClick={handleOrderClick}
        handleDeleteClick={handleDeleteClick}
        onInputPageChange={handleInputPageChange}
        typeFilters="usuarios"
      />
    </MainContent>
  );
};
